"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShowHideWordCount = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Anchor = require("../Anchor/Anchor");
var _withUncontrolled = require("../ShowHide/withUncontrolled");
var _excluded = ["isHidden"];
var getUpdatedContent = function getUpdatedContent(wordCount, content) {
  var arr = content.split(' ');
  if (arr.length < wordCount) {
    return content;
  }
  return arr.slice(0, wordCount).join(' ').concat(' ...');
};

/**
 * A `ShowHideWordCount` is used when the content is a string type and
 * an automatic truncation based on word count is preferred.
 *
 * If content is not a string type, e.g. containing `Anchor`, `span`, `b`, etc.,
 * please refer to `ShowHide`.
 *
 * W3C uses [`Disclosure`](https://www.w3.org/TR/wai-aria-practices-1.1/#disclosure)
 * to refer similar behavior.
 *
 * @since 8.36.0
 */
var ShowHideWordCount = (0, _withUncontrolled.withUncontrolled)( /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var text = _ref.text,
    renderButton = _ref.renderButton,
    isHidden = _ref.isHidden,
    onClick = _ref.onClick,
    wordCount = _ref.wordCount;
  /**
   * EVENT HANDLER
   */
  var onClickCallback = (0, _react.useCallback)(function () {
    if (onClick) {
      onClick(isHidden);
    }
  }, [isHidden, onClick]);

  /**
   * RENDER
   */

  // render toggle button
  var button = renderButton;
  if (typeof renderButton === 'function') {
    button = renderButton({
      isHidden: isHidden,
      ref: forwardedRef,
      onClick: onClickCallback
    });
  }

  // render children
  var content = text;
  if (isHidden) {
    content = getUpdatedContent(wordCount, content);
  }
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, content, " ", " ", " ", button);
}));
exports.ShowHideWordCount = ShowHideWordCount;
ShowHideWordCount.displayName = 'ShowHideWordCount';
ShowHideWordCount.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A ShowHide is uncontrolled by default.
   * You can specify `isHidden` to manually control the visibility of disclosable content.
   */
  // This prop will be added in withUncontrolled but will need to be exposed in the doc.
  defaultHidden: _propTypes.default.bool,
  /**
   * A ShowHide is uncontrolled by default.
   * You can specify `isHidden` to manually control the visibility of disclosable content.
   */
  isHidden: _propTypes.default.bool,
  /**
   * Function called when button is pressed.
   */
  onClick: _propTypes.default.func,
  /**
   * Function called when button is pressed.
   */
  wordCount: _propTypes.default.number,
  /**
   * Default button styling corresponding to the `appearance` prop.
   */
  renderButton: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  /**
   * Content to be displayed. Part of the content will be toggled
   * based on `wordCount`.
   */
  text: _propTypes.default.string.isRequired
} : {};
ShowHideWordCount.defaultProps = {
  defaultHidden: true,
  wordCount: 100,
  renderButton: function renderButton(_ref2) {
    var isHidden = _ref2.isHidden,
      props = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
    return /*#__PURE__*/_react.default.createElement(_Anchor.Anchor, (0, _extends2.default)({
      as: "button",
      "aria-expanded": !isHidden
    }, props), isHidden ? 'See more' : 'See less');
  }
};